import { fetchWithHandling } from "utils/common-utils";
import { CreateVehicleRq, UpdateVehicleRq, Vehicle } from "utils/interfaces";

const API_URL = `${process.env.REACT_APP_BACKEND_API_PREFIX}/api/v1/vehicles`;

export const getAll = async (
    jwtToken: string,
    onSessionExpired: () => void
): Promise<Vehicle[]> => {
    try {
        const jsonData = await fetchWithHandling(
            API_URL,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            },
            () => { onSessionExpired(); }
        );
        return (jsonData as Vehicle[]) ?? [];
    } catch (error) {
        return [];
    }
};

export const create = async (
    jwtToken: string,
    onSessionExpired: () => void,
    data: CreateVehicleRq
): Promise<Vehicle | null> => {
    try {
        const jsonData = await fetchWithHandling(
            API_URL,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: JSON.stringify(data),
            },
            () => { onSessionExpired(); }
        );
        return jsonData as Vehicle;
    } catch (error) {
        return null;
    }
};

export const update = async (
    jwtToken: string,
    onSessionExpired: () => void,
    data: UpdateVehicleRq
): Promise<Vehicle | null> => {
    try {
        const jsonData = await fetchWithHandling(
            `${API_URL}/${data.id}`,
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: JSON.stringify({ name: data.name, plate: data.plate }),
            },
            () => { onSessionExpired(); }
        );
        return jsonData as Vehicle;
    } catch (error) {
        return null;
    }
};

export const deleteVehicle = async (
    jwtToken: string,
    onSessionExpired: () => void,
    id: number
): Promise<boolean> => {
    try {
        await fetchWithHandling(
            `${API_URL}/${id}`,
            {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            },
            () => { onSessionExpired(); }
        );
        return true;
    } catch (error) {
        return false;
    }
};
